import React from "react";
import "./style.css";

const Card = () => {
  return (
    <div className="container px-4">
      <div class="col-12 my-5 organiser-colmn">
        <div class="card organizer-card border-0">
          <div className="card-body p-4">
            <div className="card-title d-flex justify-content-between mb-5">
              <h6 className="fw-bold">Organizer name</h6>
              <h6 className="fw-bold">23 Jan 2023</h6>
            </div>
            <p class="card-desc pe-4 fw-semibold mb-4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea Ut enim ad minim ve niam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea
            </p>
            <iframe
              className="rounded"
              width="95%"
              height="300px"
              src="https://www.youtube.com/embed/tgbNymZ7vqY"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
